import { useState, useEffect, useContext } from 'react';
import AnimatedCheckmark from './AnimatedCheckmark';
import AnimationContext from '../../contexts/AnimationContext';

export default function RegtriggeringAnimatedCheckmark(props) {
  const [visible, setVisible] = useState(true);
  const [showScaleAnimation, setShowScaleAnimation] = useState(false);
  const [showFadeCheckmarkAnimation, setShowFadeCheckmarkAnimation] = useState(false);
  const animationContext = useContext(AnimationContext);

  useEffect(() => {
    const shouldAnimate =
    animationContext.isAnimationInState('product_choice_added', 'callback') ||
    animationContext.isAnimationInState('on_variant_change_select', 'callback') ||
    animationContext.isAnimationInState('auto_open_popup_mobile', 'callback') ||
    animationContext.isAnimationInState('auto_open_popup_desktop', 'callback')

    if (shouldAnimate) {
      setVisible(false);
      if ((['on_variant_change_select']).includes(animationContext.animationName)) {
        setShowScaleAnimation(true);
        setShowFadeCheckmarkAnimation(false)
      }

      if ((['auto_open_popup_desktop', 'auto_open_popup_mobile', 'product_choice_added']).includes(animationContext.animationName)) {
        setShowFadeCheckmarkAnimation(true);
        setShowScaleAnimation(false)
      }
      setTimeout(() => setVisible(true), 0);
    }
  }, [props.animationTriggerValue, animationContext.animationName]);
  return visible ? <AnimatedCheckmark {...props} fadeCheckmarkAnimation={showFadeCheckmarkAnimation} scaleAnimation={showScaleAnimation}/> : null;
}
